import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

function generateBrowserUid() {
    let uniqueIdPartFirst = Math.random().toString(36).substring(2) + Date.now().toString(36);
    let uniqueIdPartSecond = Math.random().toString(36).substring(2) + Date.now().toString(36);
    return uniqueIdPartFirst + uniqueIdPartSecond;
}

export const store = new Vuex.Store({
    state: {
        token: localStorage.getItem('user-token') || false,
        afterLoginToken: false,
        afterLoginUsername: false,
        isForceLogout: false,
        status: '',
        surveyList: [],
        questionnaireDetail: [],
        activeBlock: false,
        loader: false,
        submitAllowed: false,
        additionalGetParams: [],
        theme: {
            background_color: '',
            button_color: '#f93e56',
            logo_path: false,
            radio_button_checked_path: false,
            radio_button_unchecked_path: false,
            companyUid: '',
            star_rating_button_color: '#f93e56',
            nps_rating_button_color: '#f93e56',
            radio_button_color: '#f93e56',
            panel_box_shadow_color: '',
            logo_size_px: '',
            text_transform: 'uppercase',
            text_color: 'black',
            questionnaire_border_color: '',
            radio_button_background_color: '#FFF',
            button_text_color: 'white'
        },
        postSurveyConfig: {
            autoRedirectToQuestionnaire: false
        },
        currentUser: {
            username: 'my username'
        },
        defaultLanguage: 'en-US',
        tempBrowserUid: '',
        surveyReplaces: [],
        phoneVerifyUid: false,
        codeValidateResult: false
    },
    getters: {
        authStatus: state => state.status,
        surveyList: state => {
            return state.surveyList
        },
        questionnaireDetail: state => {
            return state.questionnaireDetail
        },
        activeBlockIndex: state => {
            return state.activeBlock
        },
        lastBlock: state => {
            return state.activeBlock === state.questionnaireDetail.length - 1 && state.loader === false;
        },
        isLoader: state => {
            return state.loader;
        },
        isSubmitAllowed: state => {
            return state.submitAllowed;
        },
        getAccessToken: state => {
            if (state.afterLoginToken) {
                return state.afterLoginToken
            } else {
                return state.token
            }
        },
        getAdditionalGetParams: state => {
            return state.additionalGetParams;
        },
        getBackgroundColor: state => {
            return state.theme.background_color;
        },
        getButtonColor: state => {
            return state.theme.button_color;
        },
        getRadioButtonCheckedPath: state => {
            return state.radio_button_checked_path;
        },
        getRadioButtonUnCheckedPath: state => {
            return state.radio_button_unchecked_path;
        },
        getLogoPath: state => {
            return state.theme.logo_path;
        },
        getLogoSizePx: state => {
            return state.theme.logo_size_px + 'px';
        },
        getUsername: (state) => {
            if (state.afterLoginUsername) {
                return state.afterLoginUsername
            } else {
                return localStorage.getItem('user-username')
            }
        },
        getDefaultLanguage: state => {
            return state.defaultLanguage
        },
        getCompanyUid: state => {
            return state.theme.companyUid
        },
        getIsForceLogout: state => {
            return state.isForceLogout
        },
        getBrowserUid: state => {
            if (state.tempBrowserUid) {
                return state.tempBrowserUid
            }

            let stored = null;
            try {
                stored = localStorage.getItem('browser-uid')
            } catch (e) {
                stored = null
            }

            if (stored) {
                state.tempBrowserUid = stored;
                return stored
            }

            // Lazy fallback: never return an empty/null uid, otherwise the header
            // is shared across clients and the backend anti-duplicate guard would
            // silently swallow submissions.
            let generated = generateBrowserUid();
            try {
                localStorage.setItem('browser-uid', generated)
            } catch (e) {
                // localStorage unavailable (private mode / iframe): keep it in memory
            }
            state.tempBrowserUid = generated;
            return generated
        },
        getStarRatingButtonColor: state => {
            return state.theme.star_rating_button_color
        },
        getRadioButtonColor: state => {
            return state.theme.radio_button_color
        },
        getNpsButtonColor: state => {
            return state.theme.nps_rating_button_color
        },
        getPanelBoxShadowColor: state => {
            return state.theme.panel_box_shadow_color
        },
        getSurveyReplaces: state => {
            return state.surveyReplaces
        },
        // service
        getPhoneVerifySession: state => {
            return state.phoneVerifyUid
        },
        getPhoneValidateResult: state => {
            return state.codeValidateResult
        },
        getTextTransform: state => {
            return state.theme.text_transform
        },
        getTextColor: state => {
            return state.theme.text_color
        },
        getSurveyPanelBorderColor: state => {
            return state.theme.questionnaire_border_color
        },
        getRadioButtonBackgroundColor: state => {
            return state.theme.radio_button_background_color
        },
        getAutoRedirectToQuestionnaire: state => {
            return state.postSurveyConfig.autoRedirectToQuestionnaire
        },
        getButtonTextColor: state => {
            return state.theme.button_text_color
        }
    },
    mutations: {
        /** auth **/
        AUTH_REQUEST: (state) => {
            state.status = 'loading'
        },
        AUTH_SUCCESS: (state, data) => {
            state.status = 'success';
            state.afterLoginToken = data.token
            state.afterLoginUsername = data.username;
            localStorage.setItem('user-token', data.token); // store the token in localstorage
            localStorage.setItem('user-username', data.username); // store the token in localstorage
        },
        AUTH_ERROR: (state) => {
            state.status = 'error'
        },
        SURVEY_LIST: (state, data) => {

            state.surveyList = [];

            state.surveyList = data;
        },
        QUESTIONNAIRE_DETAIL: (state, data) => {

            state.questionnaireDetail = [];

            data.forEach((item, index) => {
                if (index === 0) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                // next we need deal with questions have dependencies
                let questions = item.questions;
                questions.forEach((questionItem) => {
                    if (questionItem.depend.length > 0) {
                        // hide question because it depend on answer from another question
                        questionItem.hide_by_depend = true;
                    }
                });
                item.questions = questions;
                state.questionnaireDetail.push(item);
                state.activeBlock = 0;
            });
        },
        ADDITIONAL_REPLACES: (state, data) => {
            data.forEach((item) => {
                state.surveyReplaces.push(item);
            })
        },
        ADDITIONAL_GET_PARAMS: (state, data) => {

            data.forEach((item) => {
                state.additionalGetParams.push(item);
            })

        },
        NEXT_BLOCK: (state) => {

            state.activeBlock = state.activeBlock + 1;
            console.log(state.activeBlock);

            let blocks = state.questionnaireDetail;
            state.questionnaireDetail = [];

            blocks.forEach((item, index) => {
                if (index === state.activeBlock) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                state.questionnaireDetail.push(item);
            });
        },
        SET_LOADER: (state, value) => {
            state.loader = value;
        },
        SET_QUESTION_FILLED: (state, uid) => {

            let blocks = state.questionnaireDetail;

            blocks.forEach((item, indexBlock) => {
                let questions = item.questions;
                questions.forEach((item, indexQuestion) => {
                    if (item.uid === uid) {
                        item.filled = true;
                        item.required_error = false;
                        item.email_error = false;
                        state.questionnaireDetail[indexBlock]['questions'][indexQuestion] = item;
                    }
                });
            });
        },
        VALIDATE_ACTIVE_BLOCK: (state) => {

            state.submitAllowed = true;

            state.questionnaireDetail.forEach((block, indexBlock) => {
                if (indexBlock === state.activeBlock) {
                    let questions = block.questions;
                    // first validate simple questions
                    questions.forEach((question, indexQuestion) => {
                        let answers = question.answers;
                        let selectedCount = 0;
                        if (question.is_required) {
                            state.questionnaireDetail[indexBlock]['questions'][indexQuestion].required_error = false;
                            switch (question.type) {
                                case 'radio':
                                case 'star':
                                case 'heart':
                                case 'nps':
                                case 'plus':
                                case 'pepper':
                                case 'fire':
                                case 'select':
                                    if (!question.filled) {
                                        state.questionnaireDetail[indexBlock]['questions'][indexQuestion].required_error = true;
                                        state.submitAllowed = false;
                                    }
                                    break;
                                case 'checkbox':
                                    answers.forEach((answer) => {
                                        if (answer.selected) {
                                            selectedCount++
                                        }
                                    });
                                    if (!selectedCount) {
                                        state.questionnaireDetail[indexBlock]['questions'][indexQuestion].required_error = true;
                                        state.submitAllowed = false;
                                    }
                                    break;
                                case 'textarea':
                                case 'input':
                                case 'datetime':
                                    answers.forEach((answer) => {
                                        console.log(answer);
                                        if (!answer.value) {
                                            state.questionnaireDetail[indexBlock]['questions'][indexQuestion].required_error = true;
                                            state.submitAllowed = false;
                                        }
                                    });
                                    break;
                                case 'phone_verify':
                                    answers.forEach((answer) => {
                                        console.log(answer);
                                        if (answer.verify_code_invalid === true) {
                                            state.questionnaireDetail[indexBlock]['questions'][indexQuestion].required_error = true;
                                            state.submitAllowed = false;
                                        }
                                    });
                                    break;
                            }
                        }

                        if (question.uid === '_yKYLI1bL_bAGnI3wUWSD6oxCwz0DeEfitOM') {

                            state.questionnaireDetail[indexBlock]['questions'][indexQuestion].email_error = false
                            answers.forEach((answer) => {
                                if(answer.value) {
                                    const email = answer.value.trim();
                                    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

                                    if (email && !isEmailValid) {
                                        state.questionnaireDetail[indexBlock]['questions'][indexQuestion].email_error = true;
                                        state.submitAllowed = false;
                                    }
                                }
                            });
                        }
                    });
                }
            });
        },
        LOAD_THEME: (state, data) => {

            state.defaultLanguage = data.defaultLanguage;

            console.log(data.company.uid);
            console.log(data.theme);
            state.theme.companyUid = data.company.uid;
            if (data.theme.background_color) {
                state.theme.background_color = data.theme.background_color;
            }
            if (data.theme.logo_path) {
                state.theme.logo_path = data.theme.logo_path;
            }
            if (data.theme.button_color) {
                state.theme.button_color = data.theme.button_color;
            }
            if (data.theme.star_rating_button_color) {
                state.theme.star_rating_button_color = data.theme.star_rating_button_color;
            }
            if (data.theme.nps_rating_button_color) {
                state.theme.nps_rating_button_color = data.theme.nps_rating_button_color;
            }
            if (data.theme.radio_button_color) {
                state.theme.radio_button_color = data.theme.radio_button_color
            }
            if (data.theme.panel_box_shadow_color) {
                state.theme.panel_box_shadow_color = data.theme.panel_box_shadow_color
            }
            if (data.theme.logo_size_px) {
                state.theme.logo_size_px = data.theme.logo_size_px
            }
            if(data.theme.text_lowercase) {
                state.theme.text_transform = 'none';
            }
            if(data.theme.text_color) {
                state.theme.text_color = data.theme.text_color;
            }
            if(data.theme.questionnaire_border_color) {
                state.theme.questionnaire_border_color = data.theme.questionnaire_border_color
            }
            if(data.theme.radio_button_background_color) {
                state.theme.radio_button_background_color = data.theme.radio_button_background_color
            }
            if(data.postSurveyConfig.autoRedirectToQuestionnaire) {
                state.postSurveyConfig.autoRedirectToQuestionnaire = data.postSurveyConfig.autoRedirectToQuestionnaire;
            }
            if(data.theme.button_text_color) {
                state.theme.button_text_color = data.theme.button_text_color
            }
        },
        CHECK_DEPENDENCIES: (state, dependItem) => {
            let blocks = state.questionnaireDetail;
            blocks.forEach((blockItem) => {
                let questions = blockItem.questions;
                questions.forEach((questionItem) => {
                    // if depend answers is selected
                    let answers = questionItem.answers;
                    answers.forEach((answerItem) => {
                        if (answerItem.selected && answerItem.uid === dependItem.answer_uid) {
                            questionItem.hide_by_depend = false;
                        }
                    });
                });
            });
        },
        LOGOUT_SUCCESS: (state) => {
            localStorage.removeItem('user-token');
            localStorage.removeItem('user-username');
            state.isForceLogout = true
        },
        GENERATE_BROWSER_UID: (state) => {
            if (state.tempBrowserUid) {
                return;
            }

            let stored = null;
            try {
                stored = localStorage.getItem('browser-uid')
            } catch (e) {
                stored = null
            }

            if (stored) {
                state.tempBrowserUid = stored;
                return;
            }

            let generated = generateBrowserUid();
            try {
                localStorage.setItem('browser-uid', generated)
            } catch (e) {
                // localStorage unavailable (private mode / iframe): keep it in memory
            }
            state.tempBrowserUid = generated;
        },
        SEND_VERIFY_CODE_REQUEST: (state, data) => {

            state.codeValidateResult = 0;

            state.phoneVerifyUid = data.uid;

        },
        SEND_VALIDATE_CODE_REQUEST: (state, data) => {

            if(data.success === true) {
                state.codeValidateResult = 1;
            } else {
                state.codeValidateResult = 2;
            }
        },
    },
    actions: {
        /** auth **/
        AUTH_REQUEST: ({commit}, user) => {
            return new Promise((resolve, reject) => { // The Promise used for router redirect in login
                commit('SET_LOADER', true);
                Vue.prototype.$http({url: process.env.VUE_APP_API_AUTH_URL, data: user, method: 'POST'})
                    .then(resp => {
                        const data = {
                            token: resp.data.token,
                            username: resp.data.currentUser.username
                        }
                        commit('AUTH_SUCCESS', data);
                        // you have your token, now log in your user :)
                        commit('SET_LOADER', false);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('AUTH_ERROR', err);
                        commit('SET_LOADER', false);
                        localStorage.removeItem('user-token'); // if the request fails, remove any possible user token if possible
                        reject(err)
                    })
            })
        },
        AUTH_LOGOUT: ({commit}) => {
            return new Promise((resolve, reject) => { // The Promise used for router redirect in login
                commit('SET_LOADER', true);
                Vue.prototype.$http({url: process.env.VUE_APP_API_AUTH_URL + '/default/logout', method: 'POST'})
                    .then(resp => {
                        commit('LOGOUT_SUCCESS');
                        // you have your token, now log in your user :)
                        commit('SET_LOADER', false);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('SET_LOADER', false);
                        reject(err)
                    })
            })
        },
        SURVEY_LIST: ({commit}) => {
            commit('SET_LOADER', true);
            return new Promise((resolve, reject) => { // The Promise used for router redirect in login
                //commit('SURVEY_LIST');
                Vue.prototype.$http({url: `${process.env.VUE_APP_API_URL}/survey/list`, method: 'GET'})
                    .then(resp => {
                        const data = resp.data;
                        commit('SURVEY_LIST', data);
                        commit('SET_LOADER', false);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('SET_LOADER', false);
                        reject(err)
                    })
            })
        },
        QUESTIONNAIRE_DETAIL: ({commit}, uid) => {
            commit('SET_LOADER', true);
            return new Promise((resolve, reject) => { // The Promise used for router redirect in login
                //commit('QUESTIONNAIRE_DETAIL');
                Vue.prototype.$http({
                    url: `${process.env.VUE_APP_API_URL}/survey/detail`, method: 'GET', params: {
                        uid: uid
                    }
                })
                    .then(resp => {
                        const data = resp.data;
                        commit('QUESTIONNAIRE_DETAIL', data['questionnaire']);
                        commit('ADDITIONAL_GET_PARAMS', data['getParams']);
                        commit('ADDITIONAL_REPLACES', data['replaces']);
                        commit('SET_LOADER', false);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('SET_LOADER', false);
                        reject(err)
                    })
            })
        },
        RUN_VALIDATE: ({commit}) => {
            commit('VALIDATE_ACTIVE_BLOCK');
        },
        NEXT_BLOCK: ({commit}) => {
            commit('SET_LOADER', true);
            commit('NEXT_BLOCK');
            commit('SET_LOADER', false);
        },
        SET_QUESTION_FILLED: ({commit}, uid) => {
            commit('SET_QUESTION_FILLED', uid);
        },
        VALIDATE_REQUIRED: ({commit}, uid) => {
            commit('VALIDATE_REQUIRED', uid);
        },
        SUBMIT_SURVEY: ({commit, dispatch}, data) => {
            console.log(commit, dispatch);
            return new Promise((resolve, reject) => {
                // The Promise used for router redirect in login
                Vue.prototype.$http({
                    method: 'post', url: `${process.env.VUE_APP_API_URL}/survey/submit`, data: data
                })
                    .then(function (response) {
                        //handle success
                        resolve(response);
                    })
                    .catch(function (response) {
                        //handle error
                        reject(response);
                    });
            });
        },
        LOAD_THEME: ({commit}, data = 0) => {
            commit('SET_LOADER', true);
            return new Promise((resolve, reject) => { // The Promise used for router redirect in login
                Vue.prototype.$http({
                    url: `${process.env.VUE_APP_API_URL}/theme/theme-load`, method: 'GET', params: {
                        acl_uid: data
                    }
                })
                    .then(resp => {
                        const data = resp.data;
                        if (data) {
                            commit('LOAD_THEME', data);
                        }
                        commit('SET_LOADER', false);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('SET_LOADER', false);
                        reject(err)
                        reject(err)
                    })
            })
        },
        CHECK_DEPENDENCIES: ({commit}, data) => {
            commit('CHECK_DEPENDENCIES', data);
        },
        GENERATE_BROWSER_UID: ({commit}) => {
            commit('GENERATE_BROWSER_UID');
        },
        SEND_VERIFY_CODE_REQUEST: ({commit}, data) => {

            return new Promise((resolve, reject) => {
                Vue.prototype.$http({
                    url: process.env.VUE_APP_API_URL + '/service/send-code', data: data, method: 'POST'
                })
                    .then(resp => {

                        const data = resp.data;

                        commit('SEND_VERIFY_CODE_REQUEST', data);

                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            });
        },
        SEND_VALIDATE_CODE_REQUEST: ({commit}, data) => {

            return new Promise((resolve, reject) => {
                Vue.prototype.$http({
                    url: process.env.VUE_APP_API_URL + '/service/validate-code', data: data, method: 'POST'
                })
                    .then(resp => {

                        const data = resp.data;

                        commit('SEND_VALIDATE_CODE_REQUEST', data);

                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            });
        }
    },
});
